import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { ReactComponent as TeamIcon } from "../../../../../assets/images/People/Customers/team.svg";
import { ReactComponent as GroupsIcon } from "../../../../../assets/images/People/Customers/groups.svg";
import CustomerDetailChip from "../../Customers/CustomerDetail/CustomerDetailChip";
import { sectionCardSx, sectionTitleSx } from "./agentDetailSectionStyles";

function ChipRow({ labels }) {
  if (!labels?.length) {
    return (
      <Typography sx={{ fontSize: 16, color: "#405261", fontFamily: "Inter" }}>—</Typography>
    );
  }

  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.75 }}>
      {labels.map((label) => (
        <CustomerDetailChip key={label} label={label} />
      ))}
    </Box>
  );
}

export default function AgentDetailGroupsTeamSection({ agent }) {
  return (
    <Box sx={{ mb: 3 }}>
      <Typography sx={sectionTitleSx}>Groups & Team</Typography>
      <Box sx={sectionCardSx}>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}>
          <Box>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
              <TeamIcon />
              <Typography
                sx={{
                  color: "#405261",
                  fontFamily: "Inter",
                  fontSize: 14,
                  fontWeight: 400,
                  lineHeight: "18px",
                }}
              >
                Team
              </Typography>
            </Box>
            <ChipRow labels={agent.teams} />
          </Box>
          <Box>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
              <GroupsIcon />
              <Typography
                sx={{
                  color: "#405261",
                  fontFamily: "Inter",
                  fontSize: 14,
                  fontWeight: 400,
                  lineHeight: "18px",
                }}
              >
                Groups
              </Typography>
            </Box>
            <ChipRow labels={agent.groups} />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
